import { render, staticRenderFns } from "./how_to_use.vue?vue&type=template&id=f6f75838&lang=pug"
import script from "./how_to_use.vue?vue&type=script&lang=js"
export * from "./how_to_use.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports